import React, { useState, useEffect, useMemo } from 'react';

function Warehouse() {
  // Загрузка из localStorage
  const [items, setItems] = useState(() => {
    const saved = localStorage.getItem('khepri_warehouse_items');
    return saved ? JSON.parse(saved) : [
      { id: 1, name: 'Доска дубовая', sku: 'WOOD-001', quantity: 150, unit: 'м²', minStock: 50, price: 850, supplier: 'ООО ЛесПром' },
      { id: 2, name: 'Саморезы 4×40', sku: 'SCR-004', quantity: 2000, unit: 'шт', minStock: 500, price: 1.2, supplier: 'ООО Крепёж' },
      { id: 3, name: 'Ткань обивка серая', sku: 'FAB-012', quantity: 80, unit: 'м', minStock: 30, price: 450, supplier: 'ИП Текстиль' },
      { id: 4, name: 'ЛДСП 16мм белый', sku: 'LDSP-016', quantity: 25, unit: 'лист', minStock: 10, price: 1200, supplier: 'ООО МебельКомплект' },
      { id: 5, name: 'Кромка ПВХ 0.4мм', sku: 'EDGE-004', quantity: 300, unit: 'м', minStock: 100, price: 35, supplier: 'ООО Кромка' },
    ];
  });

  const [purchases, setPurchases] = useState(() => {
    const saved = localStorage.getItem('khepri_warehouse_purchases');
    return saved ? JSON.parse(saved) : [
      { id: 1, item: 'ЛДСП 16мм белый', quantity: 15, date: '2026-06-10', supplier: 'ООО МебельКомплект', total: 18000, status: 'В пути' },
      { id: 2, item: 'Ткань обивка серая', quantity: 50, date: '2026-06-12', supplier: 'ИП Текстиль', total: 22500, status: 'Заказано' },
      { id: 3, item: 'Саморезы 4×40', quantity: 1000, date: '2026-06-08', supplier: 'ООО Крепёж', total: 1200, status: 'Получено' },
    ];
  });

  const [showAddForm, setShowAddForm] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('name');
  const [newItem, setNewItem] = useState({ name: '', sku: '', quantity: '', unit: 'шт', minStock: '', price: '', supplier: '' });

  // Сохранение в localStorage
  useEffect(() => {
    localStorage.setItem('khepri_warehouse_items', JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    localStorage.setItem('khepri_warehouse_purchases', JSON.stringify(purchases));
  }, [purchases]);

  // Фильтрация и сортировка
  const filteredItems = useMemo(() => {
    let filtered = items.filter(item =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.sku.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.supplier.toLowerCase().includes(searchQuery.toLowerCase())
    );

    if (sortBy === 'name') {
      filtered.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortBy === 'quantity') {
      filtered.sort((a, b) => b.quantity - a.quantity);
    } else if (sortBy === 'price') {
      filtered.sort((a, b) => b.price - a.price);
    } else if (sortBy === 'low_stock') {
      filtered.sort((a, b) => (a.quantity / a.minStock) - (b.quantity / b.minStock));
    }

    return filtered;
  }, [items, searchQuery, sortBy]);

  // Статистика
  const stats = useMemo(() => {
    const totalPositions = items.length;
    const lowStock = items.filter(i => i.quantity <= i.minStock).length;
    const totalValue = items.reduce((sum, i) => sum + (i.quantity * i.price), 0);
    const normalStock = totalPositions - lowStock;
    return { totalPositions, lowStock, normalStock, totalValue };
  }, [items]);

  const addItem = () => {
    if (!newItem.name || !newItem.sku) return;
    const item = {
      id: Date.now(),
      name: newItem.name,
      sku: newItem.sku,
      quantity: parseInt(newItem.quantity) || 0,
      unit: newItem.unit || 'шт',
      minStock: parseInt(newItem.minStock) || 0,
      price: parseFloat(newItem.price) || 0,
      supplier: newItem.supplier || 'Не указан',
    };
    setItems(prev => [...prev, item]);
    setNewItem({ name: '', sku: '', quantity: '', unit: 'шт', minStock: '', price: '', supplier: '' });
    setShowAddForm(false);
  };

  const deleteItem = (id) => {
    if (window.confirm('Удалить позицию со склада?')) {
      setItems(prev => prev.filter(item => item.id !== id));
    }
  };

  const exportCSV = () => {
    const rows = [
      ['Название', 'Артикул', 'Кол-во', 'Ед.', 'Мин. запас', 'Цена', 'Стоимость', 'Поставщик', 'Статус'],
      ...items.map(item => [item.name, item.sku, item.quantity, item.unit, item.minStock, item.price, item.quantity * item.price, item.supplier, item.quantity <= item.minStock ? 'Мало' : 'Норма']),
    ];
    const csv = rows.map(r => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Склад_Khepri.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const getStockLevel = (item) => {
    const ratio = item.quantity / item.minStock;
    if (ratio <= 0.5) return { text: '🔴 Критический', color: '#EF4444' };
    if (ratio <= 1) return { text: '🟡 Низкий', color: '#F59E0B' };
    if (ratio <= 2) return { text: '🟢 Норма', color: '#10B981' };
    return { text: '✅ Избыток', color: '#6366F1' };
  };

  return (
    <div>
      {/* Шапка */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10, marginBottom: 16 }}>
        <h2 style={{ color: '#F7DE8A', margin: 0 }}>🏭 Склад и снабжение</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => setShowAddForm(!showAddForm)} style={{ padding: '8px 16px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 13 }}>
            {showAddForm ? '✕ Закрыть' : '+ Добавить'}
          </button>
          <button onClick={exportCSV} style={{ padding: '8px 16px', background: '#8A6636', color: '#F8FAFC', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
            📥 CSV
          </button>
        </div>
      </div>

      {/* Статистика */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 20 }}>
        <div style={{ background: '#1E293B', padding: 12, borderRadius: 8, border: '1px solid #8A6636', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8' }}>Позиций</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#F7DE8A' }}>{stats.totalPositions}</div>
        </div>
        <div style={{ background: '#1E293B', padding: 12, borderRadius: 8, border: '1px solid #8A6636', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8' }}>Низкий запас</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#EF4444' }}>{stats.lowStock}</div>
        </div>
        <div style={{ background: '#1E293B', padding: 12, borderRadius: 8, border: '1px solid #8A6636', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8' }}>В норме</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#10B981' }}>{stats.normalStock}</div>
        </div>
        <div style={{ background: '#1E293B', padding: 12, borderRadius: 8, border: '1px solid #8A6636', textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: '#94A3B8' }}>Стоимость</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#F7DE8A' }}>{stats.totalValue.toLocaleString()} ₽</div>
        </div>
      </div>

      {/* Поиск и сортировка */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
        <input
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          placeholder="🔍 Поиск по названию, артикулу, поставщику..."
          style={{ flex: 1, minWidth: 200, padding: 10, background: '#0F172A', border: '1px solid #8A6636', borderRadius: 8, color: '#F8FAFC', fontSize: 13 }}
        />
        <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ padding: 10, background: '#0F172A', border: '1px solid #8A6636', borderRadius: 8, color: '#F8FAFC', fontSize: 13 }}>
          <option value="name">По названию</option>
          <option value="quantity">По количеству</option>
          <option value="price">По цене</option>
          <option value="low_stock">Сначала проблемные</option>
        </select>
      </div>

      {/* Форма добавления */}
      {showAddForm && (
        <div style={{ marginBottom: 20, padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636', animation: 'fadeIn 0.3s' }}>
          <h3 style={{ marginBottom: 12, color: '#F7DE8A' }}>Новая позиция</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
            <input value={newItem.name} onChange={e => setNewItem({...newItem, name: e.target.value})} placeholder="Название *" style={inputStyle} />
            <input value={newItem.sku} onChange={e => setNewItem({...newItem, sku: e.target.value})} placeholder="Артикул *" style={inputStyle} />
            <input value={newItem.quantity} onChange={e => setNewItem({...newItem, quantity: e.target.value})} placeholder="Кол-во" type="number" style={inputStyle} />
            <input value={newItem.unit} onChange={e => setNewItem({...newItem, unit: e.target.value})} placeholder="Ед. (шт, м, кг)" style={inputStyle} />
            <input value={newItem.minStock} onChange={e => setNewItem({...newItem, minStock: e.target.value})} placeholder="Мин. запас" type="number" style={inputStyle} />
            <input value={newItem.price} onChange={e => setNewItem({...newItem, price: e.target.value})} placeholder="Цена" type="number" style={inputStyle} />
            <input value={newItem.supplier} onChange={e => setNewItem({...newItem, supplier: e.target.value})} placeholder="Поставщик" style={{...inputStyle, gridColumn: 'span 3'}} />
          </div>
          <button onClick={addItem} style={{ marginTop: 12, padding: '10px 24px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700 }}>
            Добавить на склад
          </button>
        </div>
      )}

      {/* Таблица склада */}
      <h3 style={{ marginBottom: 10, color: '#F7DE8A' }}>📦 Остатки ({filteredItems.length})</h3>
      <div style={{ overflowX: 'auto', marginBottom: 24 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ color: '#94A3B8', textAlign: 'left', background: '#1E293B' }}>
              <th style={{ padding: 8 }}>Название</th>
              <th style={{ padding: 8 }}>Артикул</th>
              <th style={{ padding: 8, textAlign: 'right' }}>Кол-во</th>
              <th style={{ padding: 8 }}>Ед.</th>
              <th style={{ padding: 8, textAlign: 'right' }}>Цена</th>
              <th style={{ padding: 8, textAlign: 'right' }}>Стоимость</th>
              <th style={{ padding: 8 }}>Статус</th>
              <th style={{ padding: 8 }}>Действие</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map((item) => {
              const stock = getStockLevel(item);
              return (
                <tr key={item.id} style={{ borderBottom: '1px solid #8A6636', background: stock.color === '#EF4444' ? 'rgba(239,68,68,0.05)' : 'transparent' }}>
                  <td style={{ padding: 8 }}>{item.name}</td>
                  <td style={{ padding: 8, color: '#94A3B8' }}>{item.sku}</td>
                  <td style={{ padding: 8, textAlign: 'right' }}>{item.quantity}</td>
                  <td style={{ padding: 8, color: '#94A3B8' }}>{item.unit}</td>
                  <td style={{ padding: 8, textAlign: 'right' }}>{item.price.toLocaleString()} ₽</td>
                  <td style={{ padding: 8, textAlign: 'right', color: '#F7DE8A' }}>{(item.quantity * item.price).toLocaleString()} ₽</td>
                  <td style={{ padding: 8 }}>
                    <span style={{ color: stock.color, fontSize: 12, fontWeight: 600 }}>{stock.text}</span>
                  </td>
                  <td style={{ padding: 8 }}>
                    <button onClick={() => deleteItem(item.id)} style={{ background: 'none', border: 'none', color: '#EF4444', cursor: 'pointer', fontSize: 12 }}>
                      🗑️
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Закупки */}
      <h3 style={{ marginBottom: 10, color: '#F7DE8A' }}>🛒 Заказы на закупку</h3>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ color: '#94A3B8', textAlign: 'left', background: '#1E293B' }}>
              <th style={{ padding: 8 }}>Товар</th>
              <th style={{ padding: 8, textAlign: 'right' }}>Кол-во</th>
              <th style={{ padding: 8 }}>Дата</th>
              <th style={{ padding: 8 }}>Поставщик</th>
              <th style={{ padding: 8, textAlign: 'right' }}>Сумма</th>
              <th style={{ padding: 8 }}>Статус</th>
            </tr>
          </thead>
          <tbody>
            {purchases.map((p) => (
              <tr key={p.id} style={{ borderBottom: '1px solid #8A6636' }}>
                <td style={{ padding: 8 }}>{p.item}</td>
                <td style={{ padding: 8, textAlign: 'right' }}>{p.quantity}</td>
                <td style={{ padding: 8, color: '#94A3B8' }}>{p.date}</td>
                <td style={{ padding: 8, color: '#94A3B8' }}>{p.supplier}</td>
                <td style={{ padding: 8, textAlign: 'right' }}>{p.total.toLocaleString()} ₽</td>
                <td style={{ padding: 8 }}>
                  <span style={{ color: p.status === 'Получено' ? '#10B981' : p.status === 'В пути' ? '#F59E0B' : '#94A3B8', fontSize: 12, fontWeight: 600 }}>
                    {p.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

const inputStyle = {
  padding: 10,
  background: '#0F172A',
  border: '1px solid #8A6636',
  borderRadius: 8,
  color: '#F8FAFC',
  fontSize: 13,
};

export default Warehouse;